import React from 'react'
import MediumSvg from './svgs/MediumSvg'
import { GithubSvg } from './svgs/GithubSvg'
import { YoutubeSvg } from './svgs/YoutubeSvg'
import { useTranslation } from 'react-i18next'
import { FacebookSvg } from './svgs/FacebookSvg'
import { LinkedinSvg } from './svgs/LinkedinSvg'
import { InstagramSvg } from './svgs/InstagramSvg'
import { Helmet } from 'react-helmet-async'


export function SocialIcons() {
    const { t } = useTranslation();

    return (

        <div className="flex justify-center md:justify-start lg:justify-start">
            <Helmet>
                <meta name="description" content={t("meta.description")} />
                <meta name="keywords" content={t("meta.keywords")} />
                <meta name="author" content={t("meta.author")} />
            </Helmet>
            <div className="flex space-x-1 sm:space-x- md:space-x-4 mt-2">
                <div>
                    <a href="https://www.facebook.com/Wasif.shehzad" target="_blank" rel="noopener noreferrer">
                        <div className="relative group">
                            <button
                                className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
                            >
                                <span className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-12 lg:[&>svg]:w-12">
                                    <FacebookSvg />
                                </span>
                            </button>

                            {/* Tooltip */}
                            <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                                {t('socialMedia.facebook')}
                            </span>
                        </div>
                    </a>
                </div>



                <div>
                    <a href="https://github.com/wasif-shehzad" target="_blank" rel="noopener noreferrer">
                        <div className="relative group">
                            <button
                                className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
                            >
                                <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-12 lg:[&>svg]:w-12">
                                    <GithubSvg />
                                </span>
                            </button>

                            {/* Tooltip */}
                            <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                                {t('socialMedia.github')}
                            </span>
                        </div>
                    </a>
                </div>

                <div>
                    <a href="https://www.linkedin.com/in/wasif-shehzad-2b29b798/" target="_blank" rel="noopener noreferrer">
                        <div className="relative group">
                            <button
                                className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
                            >
                                <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-12 lg:[&>svg]:w-12">
                                    <LinkedinSvg />
                                </span>
                            </button>

                            {/* Tooltip */}
                            <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                                {t('socialMedia.linkedin')}
                            </span>
                        </div>
                    </a>
                </div>

                <div>
                    <a href="https://www.instagram.com/wasif_shehzad/" target="_blank" rel="noopener noreferrer">
                        <div className="relative group">
                            <button
                                className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
                            >
                                <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-12 lg:[&>svg]:w-12">
                                    <InstagramSvg />
                                </span>
                            </button>

                            {/* Tooltip */}
                            <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                                {t('socialMedia.instagram')}
                            </span>
                        </div>
                    </a>
                </div>

                <div>
                    <a href="https://www.youtube.com/@wasifshehzad1987" target="_blank" rel="noopener noreferrer">
                        <div className="relative group">
                            <button
                                className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
                            >
                                <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-12 lg:[&>svg]:w-12">
                                    <YoutubeSvg />
                                </span>
                            </button>

                            {/* Tooltip */}
                            <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                                {t('socialMedia.youtube')}
                            </span>
                        </div>
                    </a>
                </div>

                <div className="relative group">
                    <a href="https://wasifshehzad063.medium.com/" target="_blank" rel="noopener noreferrer">
                        <div className="relative group">
                            <button
                                data-tooltip-target="medium"
                                data-tooltip-trigger="hover"
                                className="mb-2 inline-block rounded px-2 py-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
                            >
                                <span  className="[&>svg]:h-8 [&>svg]:w-8 md:[&>svg]:h-10 md:[&>svg]:w-10 lg:[&>svg]:h-12 lg:[&>svg]:w-12">
                                    <MediumSvg />
                                </span>
                            </button>

                            {/* Tooltip */}
                            <span className="absolute bottom-full left-1/2 hidden w-max -translate-x-1/2 transform rounded bg-[#ffffff] px-2 py-1 text-xs text-black opacity-0 group-hover:opacity-100 group-hover:block transition-opacity duration-150">
                                {t('socialMedia.medium')}
                            </span>
                        </div>
                    </a>
                </div>
            </div>
        </div>

    );
}

